import { EMOJI_GROUPS } from '../../data/emojis';

/**
 * Emoji panel for the composer.
 *
 * Anchored above the input row (the parent must be `relative`). The click-away
 * layer is a transparent full-screen button rather than a document listener, so
 * there is no effect to clean up. Escape closes it too - handled by the
 * composer, which owns focus.
 */
export default function EmojiPicker({ open, onPick, onClose }) {
  if (!open) return null;

  return (
    <>
      <button
        type="button"
        aria-label="Close emoji picker"
        onClick={onClose}
        tabIndex={-1}
        className="fixed inset-0 z-30 cursor-default"
      />

      <div
        role="dialog"
        aria-label="Emoji picker"
        className="animate-z2-drop absolute bottom-[calc(100%+10px)] left-0 z-40 w-[min(318px,calc(100vw-2rem))] overflow-hidden rounded-2xl border border-line bg-surface shadow-lift"
      >
        <div className="z2-scroll max-h-[252px] overflow-y-auto p-2">
          {EMOJI_GROUPS.map((group) => (
            <div key={group.id} className="mb-1 last:mb-0">
              <p className="px-2 py-1 text-[10.5px] font-semibold tracking-wider text-ink-3 uppercase">
                {group.label}
              </p>
              {/* 7 columns on phones: 8 columns of 40px cells is wider than the
                  panel, which made the grid scroll sideways on small screens. */}
              <div className="grid grid-cols-7 gap-0.5 sm:grid-cols-8">
                {group.emojis.map((emoji) => (
                  <button
                    key={emoji}
                    type="button"
                    onClick={() => onPick(emoji)}
                    aria-label={`Insert ${emoji}`}
                    className="grid h-10 w-full place-items-center rounded-lg text-[19px] leading-none transition hover:scale-110 hover:bg-surface-3 lg:h-8 lg:text-[17px]"
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
